import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.PAUSE_CAUSE}-general`,
});
